export const customStyles = {
  control: provided => ({
    ...provided,
    minHeight: '26px',
    borderRadius: 0,
    border: 'none',
    borderBottom: '1px solid #000000',
    '&:hover': {
      borderColor: '#000000'
    }
  }),
  // indicatorsContainer: provided => ({
  //   ...provided,
  //   height: '26px',
  //   padding: '0px'
  // }),
  indicatorSeparator: provided => ({
    ...provided,
    display: 'none'
  }),
  valueContainer: provided => ({
    ...provided,
    minHeight: '26px',
    padding: '0px'
  }),
  clearIndicator: provided => ({
    ...provided,
    padding: '5px'
  }),
  dropdownIndicator: provided => ({
    ...provided,
    padding: '5px',
    color: '#007AFF',
    '&:hover': {
      color: '#007AFF'
    }
  }),
  multiValueLabel: provided => ({
    ...provided,
    padding: '2px'
  }),
  multiValue: provided => ({
    ...provided
    // backgroundImage:
    //   'linear-gradient(#f4ffff 20%,#ecf6f6 50%,#ddf1fd 52%,#c7dbf3 100%)',
    // border: '1px solid #bdd1e7'
  }),
  input: provided => ({
    ...provided,
    padding: 0,
    margin: 0
  })
};
